import {typeRelateDetail} from "../ TypeRelateDetail";

export const RelateDetailsFilterData = [
    {
        "idFromColumnFilter": "detail",
        "id": "detail", "field": "position",
    },
    {
        "idFromColumnFilter": "name",
        "id": "name",
    },
    {
        "idFromColumnFilter": "typeComposition",
        "id": "typeComposition",
        "filterFn": (value, filterValue) => typeRelateDetail[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]